import React from 'react';
import { Box, Paper, Stack, Typography, alpha, useTheme } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function DefinitionItem({ title, text }) {
  const theme = useTheme();
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="flex-start"
      sx={{
        py: 1.1,
        borderTop: '1px solid',
        borderColor: alpha(theme.palette.divider, 0.8),
      }}
    >
      <InfoOutlinedIcon sx={{ color: 'primary.main', fontSize: 17, mt: 0.15 }} />
      <Box>
        <Typography sx={{ fontWeight: 700, fontSize: '0.9rem', lineHeight: 1.25 }}>
          {title}
        </Typography>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mt: 0.35, fontSize: '0.78rem', lineHeight: 1.45 }}
        >
          {text}
        </Typography>
      </Box>
    </Stack>
  );
}

export default function StatsDefinitions() {
  const theme = useTheme();
  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 1.5, sm: 2 },
        borderRadius: 3,
        backgroundColor: alpha(theme.palette.common.white, 0.78),
      }}
    >
      <Typography sx={{ fontWeight: 700, fontSize: '0.98rem' }}>
        Einordnung
      </Typography>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ display: 'block', mt: 0.35, mb: 0.4 }}
      >
        Kurz erklärt, damit die Zahlen direkt lesbar sind.
      </Typography>
      <DefinitionItem
        title="Wartezeit bis Start"
        text="Zeit zwischen Einreihen in die Warteschlange und dem tatsächlichen Beginn der Verarbeitung."
      />
      <DefinitionItem
        title="Backend-Laufzeit"
        text="Gesamte Laufzeit eines Jobs im Backend. Das ist nicht nur reine GPU-Zeit, sondern der komplette Verarbeitungsprozess."
      />
      <DefinitionItem
        title="Tempo gegenüber Echtzeit"
        text="3,0x bedeutet: 1 Minute Audio wird in rund 20 Sekunden verarbeitet."
      />
    </Paper>
  );
}
